import { render, staticRenderFns } from "./external-rights.vue?vue&type=template&id=7455d992&scoped=true&lang=pug&"
import script from "./external-rights.vue?vue&type=script&lang=js&"
export * from "./external-rights.vue?vue&type=script&lang=js&"
import style0 from "./external-rights.vue?vue&type=style&index=0&id=7455d992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7455d992",
  null
  
)

export default component.exports